import { FilterGroupEnum, } from '@honeycomb/data';
export var FilterDispatchActionType;
(function (FilterDispatchActionType) {
    FilterDispatchActionType["SET_FILTERS"] = "SetFilters";
    FilterDispatchActionType["SET_RANGE_GROUP"] = "SetRangeGroup";
    FilterDispatchActionType["SET_RANGE_GROUP_VALUES"] = "SetRangeGroupValues";
    FilterDispatchActionType["SET_CHECKBOX_GROUP"] = "SetCheckboxGroup";
    FilterDispatchActionType["SET_CHECKBOX_GROUP_ITEM_SELECTED"] = "SetCheckboxGroupItemSelected";
    FilterDispatchActionType["SET_GROUP_OPEN"] = "SetGroupOpen";
    FilterDispatchActionType["RESET_FILTERS"] = "ResetFilters";
    FilterDispatchActionType["SET_TEXT_GROUP_VALUE"] = "SetTextboxValue";
})(FilterDispatchActionType || (FilterDispatchActionType = {}));
export const filtersReducer = (filtersState, { type, filtersValue, groupIdValue, checkboxGroupValue, checkboxGroupItemSelected, checkboxGroupItemIdValue, rangeGroupValue, rangeGroupLowerValue, rangeGroupUpperValue, groupOpen, textboxValue, }) => {
    switch (type) {
        case FilterDispatchActionType.SET_FILTERS: {
            return ((filtersValue === null || filtersValue === void 0 ? void 0 : filtersValue.map((inputGroup) => {
                var _a, _b;
                return (Object.assign(Object.assign({}, inputGroup), { open: (_b = (_a = filtersState.find((currentGroup) => currentGroup.id === inputGroup.id)) === null || _a === void 0 ? void 0 : _a.open) !== null && _b !== void 0 ? _b : inputGroup.open }));
            })) || []);
        }
        case FilterDispatchActionType.SET_RANGE_GROUP: {
            if (!groupIdValue)
                return filtersState;
            let updated = false;
            const newFilters = filtersState.reduce((acc, group) => {
                if (group.id === groupIdValue) {
                    updated = true;
                    return rangeGroupValue ? [...acc, rangeGroupValue] : acc;
                }
                return [...acc, group];
            }, []);
            return updated || !rangeGroupValue ? newFilters : [...filtersState, rangeGroupValue];
        }
        case FilterDispatchActionType.SET_CHECKBOX_GROUP: {
            if (!groupIdValue)
                return filtersState;
            let updated = false;
            const newFilters = filtersState.reduce((acc, group) => {
                if (group.id === groupIdValue) {
                    updated = true;
                    return checkboxGroupValue ? [...acc, checkboxGroupValue] : acc;
                }
                return [...acc, group];
            }, []);
            return updated || !checkboxGroupValue ? newFilters : [...filtersState, checkboxGroupValue];
        }
        case FilterDispatchActionType.SET_RANGE_GROUP_VALUES:
            if (!groupIdValue)
                return filtersState;
            return filtersState.reduce((acc, group) => {
                if (group.id === groupIdValue &&
                    (group.type === FilterGroupEnum.Range || group.type === FilterGroupEnum.Pricerange)) {
                    return [
                        ...acc,
                        Object.assign(Object.assign({}, group), { lower: rangeGroupLowerValue !== null && rangeGroupLowerValue !== void 0 ? rangeGroupLowerValue : group.lower, upper: rangeGroupUpperValue !== null && rangeGroupUpperValue !== void 0 ? rangeGroupUpperValue : group.upper }),
                    ];
                }
                return [...acc, group];
            }, []);
        case FilterDispatchActionType.SET_CHECKBOX_GROUP_ITEM_SELECTED:
            if (!groupIdValue || !checkboxGroupItemIdValue)
                return filtersState;
            return filtersState.reduce((acc, group) => {
                if (group.id === groupIdValue && group.type === FilterGroupEnum.Checkbox) {
                    const newItems = group.items.reduce((itemsAcc, item) => {
                        if (item.id === checkboxGroupItemIdValue) {
                            return [...itemsAcc, Object.assign(Object.assign({}, item), { selected: checkboxGroupItemSelected || false })];
                        }
                        return [...itemsAcc, item];
                    }, []);
                    return [...acc, Object.assign(Object.assign({}, group), { items: newItems })];
                }
                return [...acc, group];
            }, []);
        case FilterDispatchActionType.SET_GROUP_OPEN:
            if (!groupIdValue)
                return filtersState;
            return filtersState.reduce((acc, group) => {
                if (group.id === groupIdValue) {
                    return [...acc, Object.assign(Object.assign({}, group), { open: groupOpen || false })];
                }
                return [...acc, group];
            }, []);
        case FilterDispatchActionType.RESET_FILTERS:
            return filtersState.reduce((acc, group) => {
                if (group.type === FilterGroupEnum.Checkbox) {
                    return [
                        ...acc,
                        Object.assign(Object.assign({}, group), { open: true, items: group.items.map((item) => (Object.assign(Object.assign({}, item), { selected: false }))) }),
                    ];
                }
                if (group.type === FilterGroupEnum.Range || group.type === FilterGroupEnum.Pricerange) {
                    return [...acc, Object.assign(Object.assign({}, group), { lower: group.min, upper: group.max, open: true })];
                }
                if (group.type === FilterGroupEnum.Text) {
                    return [...acc, Object.assign(Object.assign({}, group), { value: '', open: true })];
                }
                return [...acc, group];
            }, []);
        case FilterDispatchActionType.SET_TEXT_GROUP_VALUE:
            if (!groupIdValue)
                return filtersState;
            return filtersState.reduce((acc, group) => {
                if (group.id === groupIdValue && group.type === FilterGroupEnum.Text) {
                    return [
                        ...acc,
                        Object.assign(Object.assign({}, group), { value: textboxValue }),
                    ];
                }
                return [...acc, group];
            }, []);
        default:
            return filtersState;
    }
};
